import React, { useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import jazzcashimg from "../Assets/Images/jcLogo.webp";
import "../scss/landingjazzcash.scss";

interface LandingJazzCashProps {
  msisdn: string;
  errorMessage: string;
  isArtworkLoading: boolean;
  artworkUrl: string;
  pricePoint: string;
  disclaimerText: string;
  isLoading: boolean;
  isPrivacyPolicyChecked: boolean;
  onMsisdnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPrivacyPolicyClick?: () => void;
  onContinueClick?: () => void;
}

const LandingJazzCash = (props: LandingJazzCashProps) => {
  return (
    <>
      <div className="JC--landing--page">
        <div className="JC--main--content">
          {props.isArtworkLoading ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={300}
              sx={{ bgcolor: "#e0e0e0" }}
            />
          ) : (
            <img
              src={props.artworkUrl}
              alt="artwork"
              className="lp-main-image"
            />
          )}
          <div className="lp-absolute-content">
            <div className="numberdiv">
              <p className="landingtext">Please enter your jazzcash number</p>
              <form>
                <div className="jc--input-wraper">
                  <span>
                    <img
                      src={jazzcashimg}
                      width={60}
                      height={28}
                      alt="jazzcash"
                    />
                  </span>
                  <input
                    inputMode="numeric"
                    type="text"
                    placeholder="3XX - XXXXXXX"
                    className="numberinput"
                    maxLength={10}
                    value={props.msisdn}
                    onChange={props.onMsisdnChange}
                  />
                </div>

                <div
                  className={`landingJC--default--btn ${props.msisdn.length !== 10 ? "disabled" : ""}`}
                  onClick={props.onContinueClick}
                >
                  {props.isLoading ? "Loading..." : "Subscribe"}
                </div>
                {props.errorMessage && (
                  <p className="error">{props.errorMessage}</p>
                )}
              </form>
            </div>

            <div className="otpDiv">
              <div className="policytext">
                <p>Price Point : {props.pricePoint} Inc.Tax</p>
                <div className="checkflex">
                  <input
                    type="checkbox"
                    checked={props.isPrivacyPolicyChecked}
                    onChange={() => props.onPrivacyPolicyClick?.()}
                  />
                  <p style={{ margin: 0 }}>
                    By signing in, you agree to the{" "}
                    <a href="/terms" target="_blank" rel="noreferrer">
                      Terms of Use
                    </a>{" "}
                    and{" "}
                    <a href="/privacypolicy" target="_blank" rel="noreferrer">
                      Privacy Policy.
                    </a>
                  </p>
                </div>

                {props.disclaimerText && (
                  <div className="continue-text">{props.disclaimerText}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingJazzCash;
